import { useState } from "react";
import { Link } from "react-router-dom";
import TickIcon from "../icons/TickIcon";
import { useTranslation } from "react-i18next";

const BusinessPlanCard = ({
  title,
  subTitle,
  subTitlePrefix,
  buttonTitle,
  benefitsList,
  buttonLink,
  minSeats,
  maxSeats,
}) => {
  const { t } = useTranslation('signup');
  const [expanded, setExpanded] = useState(window.innerWidth > 768);
  const extractListItems = (html) => {
    if (!html) return [];

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    return Array.from(doc.querySelectorAll("li")).map((li) =>
      li.textContent.trim()
    );
  };
  const listItems = extractListItems(benefitsList);

  return (
    <div className={`plan-card ${expanded ? "plan-card-expanded" : ""}`}>
      <div className="plan-card__top">
        <div className="plan-card__titles">
          <p className="plan-card__title">{title}</p>
          <div style={{ display: "flex", gap: "4px" }}>
            <p className="plan-card__subtitle-prefix">{subTitlePrefix}</p>
            <p className="plan-card__subtitle">{subTitle}</p>
          </div>
          <div className="plan-card__person-count">
            {maxSeats ? (
              <p>{t("plan_people_range", { min: minSeats, max: maxSeats })}<i class="fas fa-user-friends ms-2"></i></p>
            ) : (
              <p>{t("plan_people_more_than", { min: minSeats })}<i class="fas fa-user-friends ms-2"></i></p>
            )}
          </div>
        </div>
        <Link to={buttonLink} className="plan-card__button">
          <p>{buttonTitle}</p>
        </Link>
      </div>
      <div className="plan-card__divider" />
      <div className="plan-subscription_detail">
        <ul>
          {listItems.map((item, index) => (
            <li key={index}>
              <TickIcon color="#51CAAD" className="plan-subscription_detail__tick" />
              <p>{item}</p>
            </li>
          ))}
        </ul>
      </div>
      <button
        className={`plan-card__arrow${expanded ? " plan-card__arrow--flipped" : ""}`}
        onClick={() => setExpanded((prev) => !prev)}
        aria-label="toggle benefits"
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.6094 8.39069C23.8593 8.64072 23.9998 8.9798 23.9998 9.33335C23.9998 9.68691 23.8593 10.026 23.6094 10.276L16.9427 16.9427C16.6927 17.1926 16.3536 17.3331 16 17.3331C15.6465 17.3331 15.3074 17.1926 15.0574 16.9427L8.39071 10.276C8.14783 10.0246 8.01344 9.68775 8.01648 9.33815C8.01951 8.98856 8.15974 8.65414 8.40695 8.40693C8.65416 8.15972 8.98858 8.01949 9.33817 8.01645C9.68777 8.01342 10.0246 8.14781 10.276 8.39069L16 14.1147L21.724 8.39069C21.9741 8.14073 22.3132 8.00031 22.6667 8.00031C23.0203 8.00031 23.3593 8.14073 23.6094 8.39069ZM23.6094 16.3907C23.8593 16.6407 23.9998 16.9798 23.9998 17.3334C23.9998 17.6869 23.8593 18.026 23.6094 18.276L16.9427 24.9427C16.6927 25.1927 16.3536 25.3331 16 25.3331C15.6465 25.3331 15.3074 25.1927 15.0574 24.9427L8.39071 18.276C8.14783 18.0246 8.01344 17.6878 8.01648 17.3382C8.01951 16.9886 8.15974 16.6541 8.40695 16.4069C8.65416 16.1597 8.98858 16.0195 9.33817 16.0165C9.68777 16.0134 10.0246 16.1478 10.276 16.3907L16 22.1147L21.724 16.3907C21.9741 16.1407 22.3132 16.0003 22.6667 16.0003C23.0203 16.0003 23.3593 16.1407 23.6094 16.3907Z"
            fill="#616161"
          />
        </svg>
      </button>
    </div>
  );
};

export default BusinessPlanCard;
